import { ILocationAddress, LocationTypeRevamp } from '@commenda/types';
import { fetcher } from '@commenda/utils';

export type TUpdateLocationParams = {
  locationName?: string;
  employeeCount?: number;
  isVirtualAddress?: boolean;
  startDate?: string | null;
  endDate?: string | null;
  locationTypes?: LocationTypeRevamp[];
  address?: ILocationAddress;
};

export const updateBusinessEntityLocation = async (
  businessEntityId: number,
  locationId: string,
  body: TUpdateLocationParams
) => {
  const res = await fetcher(
    `business-entities/${businessEntityId}/locations/${locationId}`,
    {
      method: 'PATCH',
      body,
    }
  );

  return res;
};
